import styled from "styled-components";
import { PriceDataContainer } from "../../common/price-styles";

export const SaludPymesPriceContainer = styled(PriceDataContainer)``;
